module.exports = __webpack_public_path__ + "static/media/football.055ad563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/football.jpg
// module id = 689
// module chunks = 0